import React, { useState, useCallback, useContext } from 'react'
import PropTypes from 'prop-types'
import setGraphQLErrors from '@orionx-dev/orionsoft-parts/lib/helpers/setGraphQLErrors'
import { Form, Field } from 'simple-react-form'
import Slider from 'App/components/fields/Slider'
import styles from './styles.css'
import { formValidation, maxValue, minValue } from './formData'
import Button from '@orionx-dev/orionsoft-parts/lib/components/Button'
import { KycContext } from 'App/KYC/Layout'
import useMessage from 'App/hooks/useMessage'

const FundsRange = ({ callNextStep, callBackStep }) => {
  const { kyc, setKyc } = useContext(KycContext)
  const showMessage = useMessage()

  const [form, setForm] = useState({ fundsRange: 0 })
  const [isFormValid, setIsFormValid] = useState(false)
  const [dataWasModified, setDataWasModified] = useState(false)

  const isFormValidFn = values => {
    return formValidation.every(field => field.isValid(values[field.fieldName]))
  }

  const save = useCallback(async () => {
    try {
      if (dataWasModified) {
        const valid = isFormValidFn(form)
        setIsFormValid(valid)
        if (!valid) {
          showMessage('Valor incorrecto en formulario')
          return
        }
      }

      setKyc({
        ...kyc,
        missingInfo: {
          ...kyc.missingInfo,
          monthlyIncome: String(form.fundsRange),
        },
      })
      callNextStep(true, dataWasModified)
    } catch (error) {
      console.error(error)
      setGraphQLErrors(error)
    }
  }, [form, dataWasModified, showMessage, callNextStep])

  const formOnChange = val => {
    setForm(val)
    setIsFormValid(isFormValidFn(val))
    setDataWasModified(true)
  }

  return (
    <Form className={styles.form} state={form} onChange={formOnChange}>
      <div>
        <div className={styles.sectionTitle}>
          <h1>Elige el rango de tus ingresos mensuales</h1>
        </div>
        <div className={styles.amount}>CLP {form.fundsRange.toLocaleString('es-CL')}</div>
        <div className={styles.slider}>
          <Field fieldName="fundsRange" type={Slider} maxValue={maxValue} minValue={minValue} />
        </div>
        <div className={styles.submit}>
          <Button onClick={callBackStep} className={styles.buttonOutline}>
            Atrás
          </Button>
          <Button onClick={save} className={styles.buttonPrimary} disabled={!isFormValid}>
            Siguiente
          </Button>
        </div>
      </div>
    </Form>
  )
}

FundsRange.propTypes = {
  callNextStep: PropTypes.func,
  callBackStep: PropTypes.func,
}

export default FundsRange
